import React from 'react';
import { Box, Text, VStack, Heading, Image, Container } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import resume from '../icons/resume.png';
import NavigationButtons from '../Components/NavigationButtons';

function ResumeResourcePage3() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/resume-resource-page-2');
  };

  const handleNext = () => {
    navigate('/resume-resource-page-4');
  };

  return (
    <Box>
      {/* Header */}
      <Box bg="#00D29D" w="100%" h="8vh" display="flex" alignItems="center" justifyContent="center">
        <Text fontSize="16px" fontWeight="semibold">Resources</Text>
      </Box>

      {/* Main Content */}
      <Container bg="white" p={6} maxW="container.md" fontFamily="Raleway">
        <VStack spacing={6} align="stretch">
          <Heading size="lg" color="#00D29D" fontFamily="Raleway">
            Resume Breakdown
          </Heading>

          <Heading size="md" fontFamily="Raleway">Education</Heading>

          <Text>
            The Education section should be placed at the top of your resume, just below your contact information. 
            List your university name, degree, major(s), minor(s), and anticipated graduation date. 
            Be sure to include your GPA if it's strong (typically 3.5 or above), and any relevant honors, 
            scholarships, or academic programs. Use consistent formatting and alignment to keep it clean and easy to scan. 
            Employers often look here first, so make this section clear and compelling.
          </Text>

          {/* New side-by-side layout */}
          <Box display="flex" alignItems="center" gap={4}>
            <Box flexShrink={0}>
              <Image 
                src={resume} 
                alt="Resume Icon"
                width="165px"
                height="134px"
              />
            </Box>
          </Box>

          <Heading size="lg" color="#00D29D" fontFamily="Raleway">
            Resume Breakdown
          </Heading>

          <Heading size="md" fontFamily="Raleway">Experience</Heading>
          <Text>
            The Experience section is the heart of your resume. It’s where you show how your previous roles and 
            responsibilities align with the job you're applying for. Each entry should start with the position title, 
            the organization’s name, location, and the time period during which you worked there. Bold your title and 
            the organization to make it stand out.
          </Text>
          <Text>
            Beneath each experience, use bullet points to describe your accomplishments, not just your duties. 
            Start each bullet with a strong action verb (e.g., "Led", "Developed", "Created", "Implemented") and 
            quantify results when possible (e.g., "increased engagement by 25%", "reduced processing time by 30%").
            Focus on impact — what did you do, how did you do it, and why did it matter?
          </Text>
          <Text>
            Consistency in formatting is key. Use past tense for completed jobs and present tense for current roles. 
            Make sure all dates are aligned on the right for easy readability. You can also divide experience into 
            subcategories like “Leadership Experience,” “Technical Experience,” or “Research Experience” if relevant.
          </Text>

          <NavigationButtons onNext={handleNext} onBack={handleBack} />
        </VStack>
      </Container>

      <Box marginTop="50px">
        <Navbar />
      </Box>
    </Box>
  );
}

export default ResumeResourcePage3;
